import React, { useState, useContext, useEffect } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
import { StoreContext } from "../store";
import Image from "react-bootstrap/Image";
import Catalog from "./catalog";

let ImportBirds = (props) => {
  const { dispatch } = useContext(StoreContext);

  // useEffect(() => {
  //   GetBirds(dispatch);
  // }, []);

  return (
    <div className="catalog-wrapper">
      <h2>Our Import Birds</h2>
      <Catalog Page="importbirds"></Catalog>
    </div>
  );
};

export default ImportBirds;
